export default {
  namespaced: true,
  testing: {
    title: "Testing",
    penetration: {
      title: "Penetration Testing",
      participant: "Participant",
      required: "This field is required",
      perticipantRequired: "At least one participant with name and profile is required",
    },
    security_box: {
      title: "Security Box Testing",
      manager: "Manager",
    },
    testResults: "Test Results",
    reopen: "Reasign",
    reopenTest: "Reasign test",
    result: "Result",
    type: "Tipe",
    maintenanceFormReference: "Maintenance Form Reference",
    existingFiles: "Existing files",
    date: "Registration Date",
    statusApprovedCanceledRejectedReagined: 'Approved/Rejected/Canceled'
  }
};
